export const reactCode = `
<button className="launch-button" onClick={openChannels}>
  Open Channels
</button>

const openChannels = () => {
    window.openChannelsWidget({
      selectedChannel: "{CHANNEL_NAME}",
      selectedTopic: "{TOPIC_NAME}",
      channels:["CHANNEL_NAME1", "CHANNEL_NAME2"],
      theme: "{THEME}",
      email:"{USER_EMAIL}",
      autoLogin: true/false,
      width: {
        default: "450px",
        sm: "100%",
      },
      height: {
        default: "90%",
        sm: "80%",
      },
      position: "right",
    });
  };
`;

export const vueCode = `
<template>
  <button @click="openChannels">Open Channels</button>
</template>

<script>
export default {
  methods: {
    openChannels() {
        if (window.openChannelsWidget) {
           window.openChannelsWidget({
            selectedChannel: "{CHANNEL_NAME}",
            selectedTopic: "{TOPIC_NAME}",
            channels:["CHANNEL_NAME1", "CHANNEL_NAME2"],
            theme: "{THEME}",
            email:"{USER_EMAIL}",
            autoLogin: true/false,
            width: {
              default: "450px",
              sm: "100%",
            },
            height: {
              default: "90%",
              sm: "80%",
            },
            position: "right",
          });
        }
    },
  },
};
</script>
`;

export const nextjsCode = `
  const openChannels = () => {
      if (window.openChannelsWidget) {
          window.openChannelsWidget({
            selectedChannel: "{CHANNEL_NAME}",
            selectedTopic: "{TOPIC_NAME}",
            channels:["CHANNEL_NAME1", "CHANNEL_NAME2"],
            theme: "{THEME}",
            email:"{USER_EMAIL}",
            autoLogin: true/false,
            width: {
              default: "450px",
              sm: "100%",
            },
            height: {
              default: "90%",
              sm: "80%",
            },
            position: "right",
          });
      }
  };

  return (
    <>
      <button onClick={openChannels}>Open Channels</button>
    </>
  );
}
`;

export const flutterCode = `import 'package:channels_flutter/channels_flutter.dart';

// Place this widget anywhere in your app:
ChannelsCommunity(
  apiKey: 'YOUR_API_KEY',
  user: ChannelsUser(
    externalId: 'YOUR_USER_ID',
    name: 'Jane',
    email: 'jane@acme.com',
  ),
)
`;

export const phpCode = `
<button onclick="openChannels()">Open Channels</button>

<script>
  function openChannels() {
      if (window.openChannelsWidget) {
          window.openChannelsWidget({
            selectedChannel: "{CHANNEL_NAME}",
            selectedTopic: "{TOPIC_NAME}",
            channels:["CHANNEL_NAME1", "CHANNEL_NAME2"],
            theme: "{THEME}",
            email:"{USER_EMAIL}",
            autoLogin: true/false,
            width: {
              default: "450px",
              sm: "100%",
            },
            height: {
              default: "90%",
              sm: "80%",
            },
            position: "right",
          });
      }
  }
</script>

`;
export const htmlJsCode = `
<button onclick="openChannels()">Community</button>

<script>
  function openChannels() {
    if (window.openChannelsWidget) {
      window.openChannelsWidget({
        selectedChannel: "{CHANNEL_NAME}",
        position: "right",
        // For JWT SSO: token: "<jwt-from-your-backend>"
        // For Trusted SSO: external_id: "user-123", name: "Jane", email: "jane@acme.com"
      });
    }
  }
</script>
`;
export const angularCode = `
<button (click)="openChannels()">Open Channels</button>


`;

export const angularTsCode = `
import { Component } from '@angular/core';

@Component({
  selector: 'app-channels-widget',
  templateUrl: './channels-widget.component.html'
})
export class ChannelsWidgetComponent {
  openChannels() {
    if (window.openChannelsWidget) {
      window.openChannelsWidget({
        selectedChannel: "{CHANNEL_NAME}",
        selectedTopic: "{TOPIC_NAME}",
        channels: ["CHANNEL_NAME1", "CHANNEL_NAME2"],
        theme: "{THEME}",
        email: "{USER_EMAIL}",
        autoLogin: true, // or false
        width: {
          default: "450px",
          sm: "100%",
        },
        height: {
          default: "90%",
          sm: "80%",
        },
        position: "right",
      });
    }
  }
}

`;

export const svelteCode = `
<script>
  function openChannels() {
    if (window.openChannelsWidget) {
      window.openChannelsWidget({
        selectedChannel: "{CHANNEL_NAME}",
        selectedTopic: "{TOPIC_NAME}",
        channels: ["CHANNEL_NAME1", "CHANNEL_NAME2"],
        theme: "{THEME}",
        email: "{USER_EMAIL}",
        autoLogin: true,
        position: "right",
      });
    }
  }
</script>

<button on:click={openChannels}>Open Channels</button>
`;

export const nuxtCode = `
<!-- Load widget.js once in nuxt.config.ts:
app: { head: { script: [{ src:
  "https://cdn.channels.social/widget.js?apiKey=YOUR_API_KEY", async: true }] } } -->

<template>
  <button @click="openChannels">Open Channels</button>
</template>

<script setup>
const openChannels = () => {
  if (import.meta.client && window.openChannelsWidget) {
    window.openChannelsWidget({
      selectedChannel: "{CHANNEL_NAME}",
      selectedTopic: "{TOPIC_NAME}",
      channels: ["CHANNEL_NAME1", "CHANNEL_NAME2"],
      theme: "{THEME}",
      email: "{USER_EMAIL}",
      autoLogin: true,
      position: "right",
    });
  }
};
</script>
`;

export const wordpressCode = `
<!-- 1) Load the widget site-wide.
     Appearance > Theme File Editor (footer.php, before </body>),
     or a "Header & Footer" / "Custom HTML" plugin. -->
<script async src="https://cdn.channels.social/widget.js?apiKey=YOUR_API_KEY"></script>

<!-- 2) Drop this launch button into any page/post via a "Custom HTML" block. -->
<button onclick="openChannels()">Open Channels</button>
<script>
  function openChannels() {
    window.openChannelsWidget && window.openChannelsWidget({
      selectedChannel: "{CHANNEL_NAME}",
      channels: ["CHANNEL_NAME1", "CHANNEL_NAME2"],
      theme: "{THEME}",
      email: "{USER_EMAIL}",
      autoLogin: true,
      position: "right",
    });
  }
</script>
`;

export const shopifyCode = `
{% comment %} 1) Online Store > Themes > Edit code > layout/theme.liquid,
   paste before </body> {% endcomment %}
<script async src="https://cdn.channels.social/widget.js?apiKey=YOUR_API_KEY"></script>

{% comment %} 2) Add a launch button to any template/section {% endcomment %}
<button onclick="openChannels()">Open Channels</button>
<script>
  function openChannels() {
    window.openChannelsWidget && window.openChannelsWidget({
      selectedChannel: "{CHANNEL_NAME}",
      theme: "{THEME}",
      email: "{{ customer.email }}",
      autoLogin: true,
      position: "right",
    });
  }
</script>
`;

export const reactNativeCode = `import React from "react";
import ChannelsCommunity from "@channels-social/react-native";

export default function Community() {
  return (
    <ChannelsCommunity
      apiKey="YOUR_API_KEY"
      user={{ external_id: "YOUR_USER_ID", name: "Jane", email: "jane@acme.com" }}
    />
  );
}
`;

export const androidCode = `
// AndroidManifest.xml:  <uses-permission android:name="android.permission.INTERNET" />
import android.os.Bundle
import android.webkit.WebView
import android.webkit.WebViewClient
import androidx.appcompat.app.AppCompatActivity

class ChannelsActivity : AppCompatActivity() {
    override fun onCreate(savedInstanceState: Bundle?) {
        super.onCreate(savedInstanceState)
        val webView = WebView(this).apply {
            settings.javaScriptEnabled = true
            settings.domStorageEnabled = true
            webViewClient = WebViewClient()
            loadUrl(
                "https://channels.social/embed/channels?apiKey=YOUR_API_KEY&channel={CHANNEL_NAME}&theme={THEME}"
            )
        }
        setContentView(webView)
    }
}
`;

export const iosCode = `
import UIKit
import WebKit

class ChannelsViewController: UIViewController {
    override func viewDidLoad() {
        super.viewDidLoad()
        let config = WKWebViewConfiguration()
        config.allowsInlineMediaPlayback = true
        let webView = WKWebView(frame: view.bounds, configuration: config)
        webView.autoresizingMask = [.flexibleWidth, .flexibleHeight]
        let url = URL(string:
            "https://channels.social/embed/channels?apiKey=YOUR_API_KEY&channel={CHANNEL_NAME}&theme={THEME}")!
        webView.load(URLRequest(url: url))
        view.addSubview(webView)
    }
}
`;

// Per-stack setup notes shown BELOW the snippet (admin Integration tab + docs),
// so the code samples stay clean.
export const MOBILE_NOTES = {
  reactnative: {
    install: "npm i @channels-social/react-native react-native-webview",
    tips: [
      "Auth is passed via the user prop — members never re-login.",
      "Push (mentions, DMs, replies) is optional: install the Firebase peers and pass enablePush. See the docs.",
    ],
  },
  flutter: {
    install: "pubspec.yaml → channels_flutter: ^0.1.0  (+ webview_flutter)",
    tips: [
      "Auth is passed via the user param — members never re-login.",
      "One widget renders on both iOS and Android.",
    ],
  },
  android: {
    install:
      'AndroidManifest.xml → <uses-permission android:name="android.permission.INTERNET" />',
    tips: [
      "Optional auto-login: append &external_id=USER_ID&name=NAME&autoLogin=true (Trusted) or &token=SIGNED_JWT&autoLogin=true (JWT) to the URL.",
    ],
  },
  ios: {
    install: "No extra dependencies — WKWebView is built in.",
    tips: [
      "Optional auto-login: append &external_id=USER_ID&name=NAME&autoLogin=true (Trusted) or &token=SIGNED_JWT&autoLogin=true (JWT) to the URL.",
    ],
  },
};
